import LandingPageHeader from '@/components/_rebrand/LandingPageHeader';
import { Container, MAX_CONTAINER_WIDTH } from '@/components/layout/Container';
import { LandingPageNavigationProps } from '@/components/navigation/LandingPageNavigation';
import LANDING_PAGE_HEADER_PROPS from '@/constants/landing-page-header';
import { FRONT_LEGAL_NAME } from '@/constants/strings';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import MasterTemplate from './MasterTemplate';

// #region - Components

const Footer = styled.footer`
  margin: 0 auto;
  ${paddingY(24)}
  max-width: ${remCalc(MAX_CONTAINER_WIDTH)};
  border-top: 1px solid ${COLORS.GRAY.HIGHLIGHT};
  ${customTextSize(11, 24)}
  color: ${COLORS.GRAY.BASE};
  text-align: center;

  ${mediaBreakpointUp('desktop')} {
    text-align: right;
  }
`;

// #endregion - Components

interface LandingPageTemplateProps extends LandingPageNavigationProps, PropsWithChildren { }

const LandingPageTemplate: FC<LandingPageTemplateProps> = ({ children, additionalLockupLogo }) => {
  return (
    <MasterTemplate
      navigation={<LandingPageHeader {...LANDING_PAGE_HEADER_PROPS} additionalLockupLogo={additionalLockupLogo} />}
      footer={
        <Container>
          <Footer>
            <span>
              &copy; {new Date().getFullYear()} {FRONT_LEGAL_NAME} All rights reserved.
            </span>
          </Footer>
        </Container>
      }
    >
      {children}
    </MasterTemplate>
  );
};

export default LandingPageTemplate;
